import { BASE_URL } from "../../data/BaseUrl";

export const fetchWorkoutExerciseStats = async (filters, TOKEN) => {
  let url = `workout/new/card_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchWorkoutExerciseStats=> ", error);
    throw error;
  }
};

export const fetchWorkoutExercise = async (filters, TOKEN) => {
  let url = `workout/new`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchWorkoutExercise=> ", error);
    throw error;
  }
};

export const fetchWorkoutEquipments = async (filters, TOKEN) => {
  let url = `equipment/new`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const workoutEquipments = {
      data: responseJson.data,
      pagination: responseJson.pagination,
      dropdown: responseJson?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.name,
        pagination: responseJson?.pagination,
        info: item || {},
      })),
    };

    return workoutEquipments;
  } catch (error) {
    console.error("fetchWorkoutEquipments=> ", error);
    throw error;
  }
};

export const fetchWorkoutCategories = async (filters, TOKEN) => {
  let url = `workoutcategory`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const workoutEquipments = {
      data: responseJson.data,
      pagination: responseJson.pagination,
      dropdown: responseJson?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.name,
        pagination: responseJson?.pagination,
        info: item || {},
      })),
    };

    return workoutEquipments;
  } catch (error) {
    console.error("fetchWorkoutCategories=> ", error);
    throw error;
  }
};

export const fetchWorkoutExerciseForDropdown = async (filters, TOKEN) => {
  let url = `workout/new`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const workoutExercise = {
      data: responseJson.data,
      pagination: responseJson.pagination,
      dropdown: responseJson?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.wo_name?.replace(/_/g, " "),
        pagination: responseJson?.pagination,
        info: item || {},
      })),
    };

    return workoutExercise;
  } catch (error) {
    console.error("fetchWorkoutExerciseForDropdown=> ", error);
    throw error;
  }
};

export const fetchWorkoutPackageStats = async (filters, TOKEN) => {
  let url = `workoutpackage/new/card_stats`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchWorkoutPackageStats=> ", error);
    throw error;
  }
};

export const fetchAllWorkoutPackages = async (filters, TOKEN) => {
  // let url = `workoutpackage/new`;
  let url = `workoutpackage/new/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("fetchAllWorkoutPackages=> ", error);
    throw error;
  }
};

export const fetchWorkoutGoal = async (filters, TOKEN) => {
  let url = `workout/goal`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    const workoutGoals = {
      data: responseJson.data,
      pagination: responseJson.pagination,
      dropdown: responseJson?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.name,
        info: item || {},
        pagination: responseJson?.pagination,
      })),
    };

    return workoutGoals;
  } catch (error) {
    console.error("fetchWorkoutGoal=> ", error);
    throw error;
  }
};

export const fetchWorkoutExperiences = async (filters, TOKEN) => {
  let url = `workoutmapping/workoutexp`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    const workoutExperiences = {
      data: responseJson.data,
      dropdown: responseJson?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.name,
        info: item || {},
      })),
    };

    return workoutExperiences;
  } catch (error) {
    console.error("fetchWorkoutExperiences=> ", error);
    throw error;
  }
};

export const fetchWorkoutMappingStats = async (filters, TOKEN) => {
  let url = `workoutmapping/stats/pt`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    return responseJson;
  } catch (error) {
    console.error("fetchWorkoutMappingStats=> ", error);
    throw error;
  }
};
